




import Vue, { PropType } from 'vue'
// List of available Icons:
// https://cdn.materialdesignicons.com/5.4.55/
import AccountGroup from 'vue-material-design-icons/AccountGroup.vue'
import AccountMultiple from 'vue-material-design-icons/AccountMultiple.vue'
import AlarmBell from 'vue-material-design-icons/AlarmBell.vue'
import AlarmLightOutline from 'vue-material-design-icons/AlarmLightOutline.vue'
import AlertOutline from 'vue-material-design-icons/AlertOutline.vue'
import Apps from 'vue-material-design-icons/Apps.vue'
import Archive from 'vue-material-design-icons/Archive.vue'
import ArrowDown from 'vue-material-design-icons/ArrowDown.vue'
import ArrowExpandHorizontal from 'vue-material-design-icons/ArrowExpandHorizontal.vue'
import ArrowLeft from 'vue-material-design-icons/ArrowLeft.vue'
import ArrowSplitVertical from 'vue-material-design-icons/ArrowSplitVertical.vue'
import ArrowUp from 'vue-material-design-icons/ArrowUp.vue'
import Atom from 'vue-material-design-icons/Atom.vue'
import BackupRestore from 'vue-material-design-icons/BackupRestore.vue'
import Bell from 'vue-material-design-icons/Bell.vue'
import Calendar from 'vue-material-design-icons/Calendar.vue'
import CarBack from 'vue-material-design-icons/CarBack.vue'
import CardTextOutline from 'vue-material-design-icons/CardTextOutline.vue'
import Chat from 'vue-material-design-icons/Chat.vue'
import CheckBold from 'vue-material-design-icons/CheckBold.vue'
import CheckCircleOutline from 'vue-material-design-icons/CheckCircleOutline.vue'
import ChevronDoubleDown from 'vue-material-design-icons/ChevronDoubleDown.vue'
import ChevronLeft from 'vue-material-design-icons/ChevronLeft.vue'
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue'
import Close from 'vue-material-design-icons/Close.vue'
import ContentDuplicate from 'vue-material-design-icons/ContentDuplicate.vue'
import ContentSave from 'vue-material-design-icons/ContentSave.vue'
import ContentSaveMove from 'vue-material-design-icons/ContentSaveMove.vue'
import CrosshairsGps from 'vue-material-design-icons/CrosshairsGps.vue'
import CursorMove from 'vue-material-design-icons/CursorMove.vue'
import DeleteForever from 'vue-material-design-icons/DeleteForever.vue'
import DotsVertical from 'vue-material-design-icons/DotsVertical.vue'
import DragHorizontal from 'vue-material-design-icons/DragHorizontal.vue'
import DragVertical from 'vue-material-design-icons/DragVertical.vue'
import Earth from 'vue-material-design-icons/Earth.vue'
import EmailMarkAsUnread from 'vue-material-design-icons/EmailMarkAsUnread.vue'
import ExitToApp from 'vue-material-design-icons/ExitToApp.vue'
import EyeOff from 'vue-material-design-icons/EyeOff.vue'
import FormatHeader1 from 'vue-material-design-icons/FormatHeader1.vue'
import Forum from 'vue-material-design-icons/Forum.vue'
import GoogleMaps from 'vue-material-design-icons/GoogleMaps.vue'
import HelpCircleOutline from 'vue-material-design-icons/HelpCircleOutline.vue'
import Information from 'vue-material-design-icons/Information.vue'
import Magnify from 'vue-material-design-icons/Magnify.vue'
import Menu from 'vue-material-design-icons/Menu.vue'
import MessageOutline from 'vue-material-design-icons/MessageOutline.vue'
import MessageReplyText from 'vue-material-design-icons/MessageReplyText.vue'
import MessageTextOutline from 'vue-material-design-icons/MessageTextOutline.vue'
import MinusBoxOutline from 'vue-material-design-icons/MinusBoxOutline.vue'
import Monitor from 'vue-material-design-icons/Monitor.vue'
import Numeric from 'vue-material-design-icons/Numeric.vue'
import Newspaper from 'vue-material-design-icons/Newspaper.vue'
import PackageVariant from 'vue-material-design-icons/PackageVariant.vue'
import Paperclip from 'vue-material-design-icons/Paperclip.vue'
import Pencil from 'vue-material-design-icons/Pencil.vue'
import Plus from 'vue-material-design-icons/Plus.vue'
import PlusBoxOutline from 'vue-material-design-icons/PlusBoxOutline.vue'
import Reply from 'vue-material-design-icons/Reply.vue'
import ResizeBottomRight from 'vue-material-design-icons/ResizeBottomRight.vue'
import Send from 'vue-material-design-icons/Send.vue'
import ShapePlus from 'vue-material-design-icons/ShapePlus.vue'
import ShapeRectanglePlus from 'vue-material-design-icons/ShapeRectanglePlus.vue'
import Star from 'vue-material-design-icons/Star.vue'
import StarOutline from 'vue-material-design-icons/StarOutline.vue'
import TableRowPlusAfter from 'vue-material-design-icons/TableRowPlusAfter.vue'
import TableRowPlusBefore from 'vue-material-design-icons/TableRowPlusBefore.vue'
import Undo from 'vue-material-design-icons/Undo.vue'
import UndoVariant from 'vue-material-design-icons/UndoVariant.vue'
import ViewDashboard from 'vue-material-design-icons/ViewDashboard.vue'
import ViewGrid from 'vue-material-design-icons/ViewGrid.vue'
import Wrench from 'vue-material-design-icons/Wrench.vue'
import ThemeLightDark from 'vue-material-design-icons/ThemeLightDark.vue'

import { UserAccess } from 'base/store/state.interface'

export default Vue.extend({
  components: {
    AccountGroup,
    AccountMultiple,
    AlarmBell,
    AlarmLightOutline,
    AlertOutline,
    Apps,
    Archive,
    ArrowDown,
    ArrowExpandHorizontal,
    ArrowLeft,
    ArrowSplitVertical,
    ArrowUp,
    Atom,
    BackupRestore,
    Bell,
    Calendar,
    CarBack,
    CardTextOutline,
    Chat,
    CheckBold,
    CheckCircleOutline,
    ChevronDoubleDown,
    ChevronLeft,
    ChevronRight,
    Close,
    ContentDuplicate,
    ContentSave,
    ContentSaveMove,
    CrosshairsGps,
    CursorMove,
    DeleteForever,
    DotsVertical,
    DragHorizontal,
    DragVertical,
    Earth,
    EmailMarkAsUnread,
    ExitToApp,
    EyeOff,
    FormatHeader1,
    Forum,
    GoogleMaps,
    HelpCircleOutline,
    Information,
    Magnify,
    Menu,
    MessageOutline,
    MessageReplyText,
    MessageTextOutline,
    MinusBoxOutline,
    Monitor,
    Newspaper,
    Numeric,
    PackageVariant,
    Paperclip,
    Pencil,
    Plus,
    PlusBoxOutline,
    Reply,
    ResizeBottomRight,
    Send,
    ShapePlus,
    ShapeRectanglePlus,
    Star,
    StarOutline,
    TableRowPlusAfter,
    TableRowPlusBefore,
    Undo,
    UndoVariant,
    ViewDashboard,
    ViewGrid,
    Wrench,
    ThemeLightDark
  },
  props: {
    name: {
      type: String as PropType<string>,
      required: true
    },
    title: {
      type: String as PropType<string>,
    },
    decorative: {
      type: Boolean as PropType<boolean>,
    },
    size: {
      type: Number as PropType<number>,
    },
    fillColor: {
      type: String as PropType<string>,
    }
  },
  computed: {
    style() {
      if (!this.size) return ''

      const relativeSize = this.size / 16
      return `width: ${relativeSize}em; height: ${relativeSize}em;`
    }
  }
})
